import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SelectorDialogData } from '../selector-dialog/selector-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-radio-selector-dialog',
  templateUrl: './radio-selector-dialog.component.html',
  styleUrl: './radio-selector-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatRadioGroup, FormsModule, MatRadioButton, MatDialogActions, MatButton],
})
export class RadioSelectorDialogComponent {
  dialogRef = inject<MatDialogRef<RadioSelectorDialogComponent>>(MatDialogRef);
  data = inject<SelectorDialogData>(MAT_DIALOG_DATA);

  value: any = null;

  submit() {
    this.dialogRef.close(this.value);
  }

  close() {
    this.dialogRef.close();
  }
}
